export default __webpack_public_path__ + "static/media/03_west_flower_b2.41fc6b79.mp4";